import { LuIcon } from "@overmap-ai/blocks"

import { modelIconMapping } from "../../../mappings/icons"
import { TextFilterDef } from "../TextFilterDef"

export class AssetLabelFilterDef extends TextFilterDef {
	readonly id = "asset-label"
	readonly icon = <LuIcon icon={modelIconMapping.text} />
	readonly label = "Label"
}
